import { Section } from "../../../patterns/Section.js";
import type { PageLayoutProps } from "../../contract.js";
import type { BoxesContent } from "../boxesContent.js";

/**
 * The boxes catalog, showroom layout: the breadcrumb, the title beside its tabs, the category
 * chips, the filters, then the top hits and the grid. On phones the tabs drop under the title.
 */
export function BoxesShowroomLayout({ sections }: PageLayoutProps<BoxesContent>) {
  return (
    <Section className="flex flex-col gap-8 pt-6 pb-20 md:gap-10">
      <div className="flex flex-col gap-4 md:gap-5">
        {sections.breadcrumb}
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          {sections.title}
          {sections.tabs}
        </div>
        {sections.categories}
        {sections.filters}
      </div>
      {sections.topHits}
      {sections.grid}
    </Section>
  );
}
